"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplyTransform = void 0;
const class_validator_1 = require("class-validator");
class ApplyTransform {
    constructor({ translateX, translateY, rotateZ, scaleIsZoom, scaleX, scaleY, opacity }) {
        this.translateX = translateX;
        this.translateY = translateY;
        this.rotateZ = rotateZ;
        this.scaleIsZoom = scaleIsZoom;
        this.scaleX = scaleX;
        this.scaleY = scaleY;
        this.opacity = opacity;
    }
    static default(transform) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (typeof transform === undefined) {
            return new ApplyTransform({
                translateX: 0,
                translateY: 0,
                rotateZ: 0,
                scaleIsZoom: false,
                scaleX: 1,
                scaleY: 1,
                opacity: 1,
            });
        }
        return new ApplyTransform({
            translateX: (_a = ApplyTransform.sum(transform === null || transform === void 0 ? void 0 : transform.translateX)) !== null && _a !== void 0 ? _a : 0,
            translateY: (_b = ApplyTransform.sum(transform === null || transform === void 0 ? void 0 : transform.translateY)) !== null && _b !== void 0 ? _b : 0,
            rotateZ: (_c = ApplyTransform.sum(transform === null || transform === void 0 ? void 0 : transform.rotateZ)) !== null && _c !== void 0 ? _c : 0,
            scaleIsZoom: (_d = transform === null || transform === void 0 ? void 0 : transform.scaleIsZoom) !== null && _d !== void 0 ? _d : false,
            scaleX: (_e = ApplyTransform.sum(transform === null || transform === void 0 ? void 0 : transform.scaleX)) !== null && _e !== void 0 ? _e : 1,
            scaleY: (_f = ApplyTransform.sum(transform === null || transform === void 0 ? void 0 : transform.scaleY)) !== null && _f !== void 0 ? _f : 1,
            opacity: (_g = ApplyTransform.sum(transform === null || transform === void 0 ? void 0 : transform.opacity)) !== null && _g !== void 0 ? _g : 1,
        });
    }
    static sum(range) {
        if (!range) {
            return undefined;
        }
        return range.min + range.max / 2;
    }
}
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Number)
], ApplyTransform.prototype, "translateX", void 0);
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Number)
], ApplyTransform.prototype, "translateY", void 0);
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Number)
], ApplyTransform.prototype, "scale", void 0);
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Number)
], ApplyTransform.prototype, "rotateZ", void 0);
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Number)
], ApplyTransform.prototype, "opacity", void 0);
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Number)
], ApplyTransform.prototype, "scaleX", void 0);
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Number)
], ApplyTransform.prototype, "scaleY", void 0);
__decorate([
    class_validator_1.IsNumber(),
    __metadata("design:type", Boolean)
], ApplyTransform.prototype, "scaleIsZoom", void 0);
exports.ApplyTransform = ApplyTransform;
